import { MessageBubble } from "./MessageBubble";
import { Column, Row, Text } from "@/components";

import { SenderGroup } from "@/lib/quoMessages";
import { cn } from "@/lib/utils";
import { QuoMessageDirection } from "@/types";

export const SenderGroupView = ({ group }: { group: SenderGroup }) => {
  const isOutgoing = group.direction === QuoMessageDirection.OUTGOING;

  /* Render */
  const render = () => (
    <Column className="w-full gap-1">
      {group.senderName && (
        <Row className={cn(isOutgoing ? "justify-end" : "justify-start")}>
          <Text className="px-1 text-xs font-normal text-slate-500">
            {group.senderName}
          </Text>
        </Row>
      )}
      <Column className="gap-0.5">
        {group.messages.map((message, index) => (
          <MessageBubble
            key={message.id}
            isFirst={index === 0}
            isLast={index === group.messages.length - 1}
            message={message}
          />
        ))}
      </Column>
    </Column>
  );

  return render();
};
